<template>
  <div class="preloader">
    <div class="spinner-blink" :style="`background: url(${logo}) no-repeat center / contain;`" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import logoDe from "@/assets/images/logo-de.svg";
import logoEn from "@/assets/images/logo-en.svg";

defineOptions({
  name: "preloader",
});

const { locale } = useI18n();
const logo = computed(() => (locale.value === "de" ? logoDe : logoEn));
</script>
